import React from 'react';
import { Tooltip } from 'antd';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from 'tailwind-merge';
import { WithConditionalWrapperHoc } from '@components/HOC/WithConditionalWrapper/WithConditionalWrapper.hoc';
import { OHIFImagingLabel } from '@dynamika-shared/types/imagingLabels';

type DicomButtonProps = {
  isViewerDisabled: boolean;
  openViewer: () => void;
  viewerStartTitle: string;
  dicomLabels?: OHIFImagingLabel[];
};

export const DicomButton = ({
  isViewerDisabled,
  openViewer,
  viewerStartTitle,
  dicomLabels,
}: DicomButtonProps) => {
  if (!dicomLabels?.length) {
    return null;
  }
  return (
    <WithConditionalWrapperHoc
      useWrapper={isViewerDisabled}
      wrapper={
        <Tooltip title='For some reason uploads failed or series not ready' />
      }
    >
      <Button
        iconType='fileDicom'
        onClick={() => {
          openViewer();
          sessionStorage.setItem('previousLocation', 'DICOM');
        }}
        className={twMerge(
          'min-w-[12rem] rounded-lg ml-1',
          !isViewerDisabled && '!text-white !bg-black hover:!bg-dodgerBlue'
        )}
        disabled={isViewerDisabled}
        type='primary'
      >
        {viewerStartTitle}
      </Button>
    </WithConditionalWrapperHoc>
  );
};
